module.exports = __webpack_public_path__ + "media/images/affiliates/affiliate-main-image-e4f3ed6af891cd02d6bb0fa8c3a51661.png";